<div  [formGroup]="laborDataForm" appAutoAudit [auditData]="fieldAuditData" [auditDisabled]="!!snapshotData">

    <div class="form-title-container">
        <h3>Datos Laborales</h3>
    </div>
    <div class="columns is-multiline ">

        <div class="column is-6 form-container">
            <span class="label">Número autorización sistema RED</span>
            <input class="search-input" type="text" pInputText formControlName="REDSystemNumber"/>
        </div>
        <div class="column is-6 form-container">
            <span class="label">Régimen Seguridad Social</span>
            <input class="search-input" type="text" pInputText formControlName="socialSecurityRegime"/>
        </div>
        <div class="column is-6 form-container">
            <span class="label">Mútua de accidentes/enfermedades profesionales</span>
            <input class="search-input" type="text" pInputText formControlName="mutualInsuranceCompany"/>
        </div>
        <div class="column is-6 form-container">
            <span class="label">Convenio colectivo aplicable</span>
            <input class="search-input" type="text" pInputText formControlName="collectiveAgreement"/>
        </div>
        <div class="column is-6 form-container">
            <span class="label">IBAN domiciliación nóminas</span>
            <p-dropdown
                [options]="bankAccounts"
                optionLabel="iban"
                optionValue="id"
                [placeholder]="snapshotData ? '' : 'Seleccionar cuenta bancaria'"
                formControlName="payrollDomiciliationIban"
                [showClear]="true"
                [appendTo]="'body'"
                [emptyFilterMessage]="'No se encontraron resultados'">
                <ng-template let-account pTemplate="item">
                    <span *ngIf="account.bankName">{{ account.bankName }} - </span>{{ account.iban | ibanFormat }}
                </ng-template>
                <ng-template let-account pTemplate="selectedItem">
                    <span *ngIf="account?.bankName">{{ account?.bankName }} - </span>{{ account?.iban | ibanFormat }}
                </ng-template>
            </p-dropdown>
        </div>
        <div class="column is-6 form-container">
            <span class="label">IBAN seguros sociales</span>
            <p-dropdown
                [options]="bankAccounts"
                optionLabel="iban"
                optionValue="id"
                [placeholder]="snapshotData ? '' : 'Seleccionar cuenta bancaria'"
                formControlName="socialInsuranceIban"
                [showClear]="true"
                [appendTo]="'body'"
                [emptyFilterMessage]="'No se encontraron resultados'">
                <ng-template let-account pTemplate="item">
                    <span *ngIf="account.bankName">{{ account.bankName }} - </span>{{ account.iban | ibanFormat }}
                </ng-template>
                <ng-template let-account pTemplate="selectedItem">
                    <span *ngIf="account?.bankName">{{ account?.bankName }} - </span>{{ account?.iban | ibanFormat }}
                </ng-template>
            </p-dropdown>
        </div>
        <div class="column is-6 form-container">
            <span class="label">Logotipo empresa</span>
            <p-fileUpload 
                name="logo[]"
                chooseLabel="Añadir" 
                customUpload="true" 
                (onSelect)="onUploadLogo($event)" 
                (onRemove)="onRemoveLogo()"
                [multiple]="false" 
                auto="true"
                accept="image/*" 
                maxFileSize="1000000">
                <ng-template pTemplate="header" let-files  let-uploadedFiles="uploadedLogo" let-chooseCallback="chooseCallback" let-removeFileCallback="removeFileCallback">
                    <div class="choose-file-container">
                          <p-button class="choose-file"(onClick)="choose($event, chooseCallback)" [rounded]="true" [outlined]="true" ><fa-icon [icon]="faFilePlus" class="add-icon"></fa-icon></p-button>
                  </div>
                  </ng-template>
                <ng-template pTemplate="content">
                    @if (uploadedLogoUrl){
                        <img [src]="uploadedLogoUrl" alt="Uploaded Logo">
                    }
                </ng-template>
            </p-fileUpload>
        </div>
    </div>
</div>

<div class="save-button-container">
    <button class="button save-button is-secondary" (click)="save()"><fa-icon class="save-icon" [icon]="faFloppyDisk"></fa-icon> Guardar</button>
</div>

@if (isSaved) {
    <div class="notification is-success">
        <div class="notification-text">
            Guardado correctamente.
        </div>
        <div class="progress-bar-container">
            <progress class="progress is-small" min="0" max="100" #progressBar></progress>
        </div>
    </div>
}